/**
 * ============================================================================
 * BAMBOOVE — THANH TIẾN TRÌNH CHO DẢI THẺ TRƯỢT (07/10/2026 · phiên 45)
 * ----------------------------------------------------------------------------
 * Gắn một thanh tiến trình BÊN DƯỚI mỗi dải thẻ trượt ngang
 * (`[data-bs-grid]` nằm trong `.bamboove-bs` — tức Best Sellers + Shop by Style).
 *
 * Hành vi theo yêu cầu chủ máy: "khi nào kéo nó mới hiện ra, còn không thì ẩn đi".
 *   • đang kéo   ⇒ thanh HIỆN (mờ dần vào 0.25s) và vạch chạy = % đã kéo
 *   • ngừng 0.9s ⇒ thanh TỰ ẨN
 *   • lúc mới vào trang: đặt sẵn độ rộng nhưng KHÔNG hiện
 *
 * Chỉ chạy ở điện thoại (≤749px) — CSS lo phần `display`. Máy tính không tốn gì
 * ngoài vài listener thụ động.
 * KHÔNG sửa file nào của theme — là file riêng của Bamboove.
 * ============================================================================
 */
(function () {
  'use strict';

  var ROOT = '.bamboove-bs';
  var DAI = '[data-bs-grid]';
  var TREO_AN = 900; /* ms ngừng kéo ⇒ ẩn */

  function gan(dai) {
    if (dai.dataset.bbTienTrinh) return;
    dai.dataset.bbTienTrinh = '1';

    var thanh = document.createElement('div');
    thanh.className = 'bamboove-tien-trinh';
    thanh.setAttribute('aria-hidden', 'true');

    var chay = document.createElement('span');
    chay.className = 'bamboove-tien-trinh__chay';
    thanh.appendChild(chay);

    dai.parentNode.insertBefore(thanh, dai.nextSibling);

    var hen = null;

    function tiLe() {
      var toiDa = dai.scrollWidth - dai.clientWidth;
      if (toiDa <= 2) return 0;
      return Math.max(0, Math.min(1, dai.scrollLeft / toiDa));
    }

    /* đặt vạch chạy nhưng KHÔNG hiện thanh (dùng lúc mới vào trang) */
    function datVach() {
      chay.style.width = (tiLe() * 100).toFixed(2) + '%';
    }

    function khiKeo() {
      datVach();
      thanh.classList.add('is-hien');
      clearTimeout(hen);
      hen = setTimeout(function () {
        thanh.classList.remove('is-hien');
      }, TREO_AN);
    }

    dai.addEventListener('scroll', khiKeo, { passive: true });
    window.addEventListener('resize', datVach, { passive: true });

    /* mới vào trang: chỉ đặt vạch, không hiện */
    datVach();
  }

  function chay() {
    document.querySelectorAll(ROOT + ' ' + DAI).forEach(gan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', chay);
  } else {
    chay();
  }

  /* trình soạn theme vẽ lại section ⇒ gắn lại */
  document.addEventListener('shopify:section:load', chay);
})();
